export default __webpack_public_path__ + "precisione7c85a.png";